import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentSfarm:{},
}

const sFarmSlice=createSlice({
name:'sFarm',

initialState,
reducers:{
    loginStartS:(state)=>{

    },
    loginSuccessS:(state,{payload})=>{
        state.isLogin=true;
        state.currentSfarm=payload;
        

    },
    loginFailureS:(state)=>{


    },
    logOutS:(state)=>{
        state.isLogin=false;
        state.currentSfarm={};

    }
    

}
})
export const {loginStartS,loginFailureS,loginSuccessS,logOutS}=sFarmSlice.actions

export default sFarmSlice.reducer